import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { TcsmStates } from '../../root/tcsm-model';
import { NavLink } from '../models/navigation-model';
import { ExternalLink } from './external-link-modal';

interface MobileNavProps {
	links: NavLink[];
	homeLinkText: string;
	homeRoute: string;
}

const OpenClass = 'nav-open';

export const MobileNavigation = (props: MobileNavProps) => {
	const { links, homeLinkText, homeRoute } = props;

	const navRef = useRef<any>();
	const [navToggle, setNavToggle] = useState('');
	const guid = useSelector<TcsmStates, string>(state => state?.authenticatedState?.clientGuid);
	useEffect(() => {
		const handleOutsideClick = (event) => {
			if (navRef.current && !navRef.current.contains(event.target)) {
				setNavToggle('');
				document.body.classList.remove(OpenClass);
			}
		};

		document.addEventListener('click', handleOutsideClick);

		return () => {
			document.removeEventListener('click', handleOutsideClick);
		};
	}, [navRef]);


	if (!links) return null;

	const toggle = () => {
		if (navToggle === OpenClass) {
			setNavToggle('');
			document.body.classList.remove(OpenClass);
		} else {
			setNavToggle(OpenClass);
			document.body.classList.add(OpenClass);
		}
	};

	return (
		<nav className='nav-mobile'>
			<div className={`nav-mobile-inner ${navToggle}`}>
				<div className='nav-mobile-bar' ref={navRef}>
					<Link className='nav-mobile-home-link' to={homeRoute}>
						<svg className='info-icon' aria-hidden='true' focusable='false'>
							<use xmlnsXlink='http://www.w3.org/2000/xlink' xlinkHref='#home-icon' />
						</svg>
						{homeLinkText}
					</Link>
					<button type='button' onClick={toggle} className={`nav-mobile-trigger ${navToggle}`}>
						<span className='visually-hidden'>TEST</span>
						<span className='nav-mobile-trigger-hamburger'></span>
					</button>


				</div>
				<div className={`nav-mobile-panel  ${navToggle}`}>
					<ul className='nav-mobile-panel-list'>
						{
							links?.map(a => {
								return (
									<li key={`${a.LinkText}-nav-mobile`} className='nav-mobile-panel-list-item'>
										{
											a?.External ?
												<ExternalLink linkUrl={a?.LinkUrl?.replace('{guid}', guid)} linkText={a.LinkText} newWindow /> :
												<Link to={a.LinkUrl}>{a.LinkText}</Link>
										}
									</li>
								);
							})
						}

					</ul>
				</div>
			</div>
		</nav>
	);

};

